import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirection = (props) => /* @__PURE__ */ _jsx("svg", {
	name: "direction",
	viewBox: "0 0 305 157",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "main-element",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#1FB790",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(152 33)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(152 100)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(48 100)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#23B7D7",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(0 67)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#23B7D7",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(48 33)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#23B7D7",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(81)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(81 133)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(105 67)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 95,
					height: 24,
					rx: 4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 4.75,
					y: 12,
					width: 19,
					height: 7.2,
					rx: 2
				})]
			})
		]
	})
});
export default SvgDirection;
